import { TabObject } from '@inmoment/the-kitchen';

export const convertArrayToTabBar = (title: string, id: number): TabObject => {
  return {
    title,
    id: `${id}`,
  };
};
